import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SessionExpiredProvider } from './context/SessionExpiredContext';
import SessionExpiredModal from './components/SessionExpiredModal';

// Admin pages
import LoginPage from './pages/LoginPage';
import AdminLoginPage from './pages/AdminLoginPage';
import RegisterPage from './pages/RegisterPage';
import BusinessAdminDashboard from './pages/BusinessAdminDashboard';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

// NOTE: User App routes are temporarily disabled - admin only deployment
// const UserApp = lazy(() => import('./app/UserApp').then(module => ({ default: module.UserApp })));

function App() {
  return (
    <Router>
      <SessionExpiredProvider>
        <Routes>
          {/* ============================================ */}
          {/* ADMIN ROUTES - All prefixed with /admin     */}
          {/* ============================================ */}
          
          {/* Business Admin Login */}
          <Route
            path="/admin/login"
            element={
              <AuthProvider>
                <LoginPage />
                <SessionExpiredModal />
              </AuthProvider>
            }
          />
          
          {/* Super Admin Login */}
          <Route
            path="/admin/super-login"
            element={
              <AuthProvider>
                <AdminLoginPage />
                <SessionExpiredModal />
              </AuthProvider>
            }
          />
          
          {/* Admin Registration */}
          <Route
            path="/admin/register"
            element={
              <AuthProvider>
                <RegisterPage />
                <SessionExpiredModal />
              </AuthProvider>
            }
          />
          
          {/* Business Admin Dashboard */}
          <Route
            path="/admin/business/*"
            element={
              <AuthProvider>
                <ProtectedRoute requiredRole="business-admin">
                  <BusinessAdminDashboard />
                </ProtectedRoute>
                <SessionExpiredModal />
              </AuthProvider>
            }
          />
          
          {/* Super Admin Dashboard */}
          <Route
            path="/admin/super/*"
            element={
              <AuthProvider>
                <ProtectedRoute requiredRole="super-admin">
                  <SuperAdminDashboard />
                </ProtectedRoute>
                <SessionExpiredModal />
              </AuthProvider>
            }
          />
          
          {/* Admin root redirect */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />

          {/* ============================================ */}
          {/* PUBLIC ROUTES                               */}
          {/* ============================================ */}
          
          {/* Privacy Policy - accessible without login */}
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

          {/* ============================================ */}
          {/* ALL OTHER ROUTES - Redirect to admin login  */}
          {/* NOTE: User app routes temporarily disabled  */}
          {/* ============================================ */}
          <Route path="/*" element={<Navigate to="/admin/login" replace />} />
        </Routes>
      </SessionExpiredProvider>
    </Router>
  );
}

export default App;
